module.exports = __webpack_public_path__ + "img/dodSettingIcon.6df4b5ed.svg";